// import Index from '@/views/index/index.vue'
import Event from '@/views/event/index.vue'
import Guide from '@/views/guide/index.vue'
import News from '@/views/news/index.vue'
import Collections from '@/views/collections/index.vue'
import CollectionDetail from '@/views/collections/detail/index.vue'
import Experts from '@/views/experts/index.vue'
import ExpertDetail from '@/views/experts/detail/index.vue'
import * as ConstantRouter from '@/constant/router'

const routes = [
  // {
  //   path: '',
  //   name: ConstantRouter.INDEX,
  //   // component: Index
  //   // 暂时不显示比赛列表给用户
  //   component: () =>
  //     import(/* webpackChunkName: "dashboard-login" */ '@/dashboard/login')
  // },
  {
    path: ':jsId(\\d+)',
    name: ConstantRouter.EVENT,
    component: Event
  },
  {
    path: 'guide/:jsId',
    name: ConstantRouter.GUIDE,
    component: Guide
  },
  {
    path: 'news/:id',
    name: ConstantRouter.NEWS,
    component: News
  },
  {
    path: 'collections',
    name: ConstantRouter.COLLECTIONS,
    component: Collections
  },
  {
    path: 'collection/:id',
    name: ConstantRouter.COLLECTION_DETAIL,
    component: CollectionDetail
  },
  {
    path: 'experts',
    name: ConstantRouter.EXPERTS,
    component: Experts
  },
  {
    path: 'expert/:id',
    name: ConstantRouter.EXPERT_DETAIL,
    component: ExpertDetail
  }
]

export default routes
